import { render, staticRenderFns } from "./FetchStatus.vue?vue&type=template&id=238625c5&"
import script from "./FetchStatus.vue?vue&type=script&lang=ts&"
export * from "./FetchStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports